var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"choose"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,on:{"click":function($event){return _vm.areaCodeClick(item)}}},[_c('p',[_vm._v(_vm._s(item.country))]),_vm._v(" "),_c('b',[_vm._v("+"+_vm._s(item.code))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a1f4c08","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/phone/boundChooseCountry.vue
// module id = null
// module chunks = 